var __default__ = {root:'m_bcb3f3c2'};
export default __default__;